const DEFAULT_MCP_BASE_URL = 'https://mcp-server-staging.dalon-mckay.workers.dev';
const DEFAULT_DASHBOARD_BASE_URL = 'https://gxp-sentinel-dashboard.pages.dev';

const configuredMcpBaseUrl = (import.meta.env.VITE_MCP_SERVER_URL ?? '').trim();
const configuredDashboardBaseUrl = (import.meta.env.VITE_DASHBOARD_URL ?? '').trim();

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getMcpBaseUrl(): string {
  return trimTrailingSlash(configuredMcpBaseUrl || DEFAULT_MCP_BASE_URL);
}

export function getDashboardBaseUrl(): string {
  return trimTrailingSlash(configuredDashboardBaseUrl || DEFAULT_DASHBOARD_BASE_URL);
}

export function getMcpEndpoint(): string {
  return `${getMcpBaseUrl()}/mcp`;
}

export function getMcpHealthUrl(): string {
  return `${getMcpBaseUrl()}/health`;
}

export function getMcpRegisterEndpoint(): string {
  return `${getDashboardBaseUrl()}/api/oauth/register`;
}

export function getMcpTokenEndpoint(): string {
  return `${getDashboardBaseUrl()}/api/oauth/token`;
}

export function getMcpCurlExample(oauthTokenPlaceholder = 'YOUR_OAUTH_ACCESS_TOKEN'): string {
  return [
    `# First, get an OAuth access token by completing the PKCE authorization flow:`,
    `# 1. Call POST ${getMcpRegisterEndpoint()} to register your client`,
    `# 2. Implement PKCE: generate code_verifier and code_challenge`,
    `# 3. Redirect user to /api/oauth/authorize with client_id and code_challenge`,
    `# 4. Exchange auth code for token at ${getMcpTokenEndpoint()}`,
    ``,
    `# Then use the access token to call the MCP server:`,
    `curl -X POST '${getMcpEndpoint()}'`,
    `  -H 'Content-Type: application/json'`,
    `  -H 'Authorization: Bearer ${oauthTokenPlaceholder}'`,
    "  -d '{",
    '    "jsonrpc": "2.0",',
    '    "id": "quickstart",',
    '    "method": "tools/call",',
    '    "params": {',
    '      "name": "gxp_search_firms",',
    '      "arguments": {',
    '        "query": "Pfizer",',
    '        "limit": 1,',
    '        "response_format": "json"',
    '      }',
    '    }',
    "  }'",
  ].join('\n');
}